import { types } from './mutations';
import { container } from 'tsyringe';
import { CandidateRepository } from 'packages/talent/CandidateRepository';
var repo = container.resolve(CandidateRepository);
var flyingPromise = null;
export var actions = {
    fetchCandidatesForCurrentCompany: function (_a, paginationQuery) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        commit(types.SET_LOADING, true);
        if (flyingPromise) {
            flyingPromise.cancel();
        }
        flyingPromise = repo.fetchCandidates(rootGetters.currentCompanyId, paginationQuery);
        flyingPromise.then(function (response) {
            commit(types.SET_PAGINATION, response.pagination);
            commit(types.SET_CANDIDATES, response.items);
            commit(types.SET_LOADING, false);
        });
    },
};
